export const TOGGLE_STATUSES = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};

export const STATUSES_BOOLEAN = {
  enabled: true,
  disabled: false,
};
